export function useComboboxContextValues(state) {
    const { activeOption, appearance, focusVisible, open, registerOption, selectedOptions, selectOption, setActiveOption, setOpen, size } = state;
    const combobox = {
        activeOption,
        appearance,
        focusVisible,
        open,
        registerOption,
        selectedOptions,
        selectOption,
        setActiveOption,
        setOpen,
        size
    };
    return {
        combobox
    };
}
